import { ROLES, useRoleCheck } from "@pharmupp/p3-front-commons"
import { AdherentMenu } from "./AdherentMenu"
import { DefaultMenu } from "./DefaultMenu"
import { LaboratoryMenu } from "./LaboratoryMenu"
import type { UserMenuImplementationProps } from "./userMenu.model"

export const UserMenu = (props: UserMenuImplementationProps) => {
  const { checkRole } = useRoleCheck()
  const isAdherentHolder = checkRole(ROLES.ADHERENT_HOLDER)
  const isAdherentTeam = checkRole(ROLES.ADHERENT_TEAM)
  const isExternLab = checkRole(ROLES.EXTERN_CONTACT_LABORATORY)

  if (isAdherentHolder || isAdherentTeam) {
    return <AdherentMenu {...props} />
  }

  if (isExternLab) {
    return <LaboratoryMenu {...props} />
  }

  return <DefaultMenu {...props} />
}
